import {Component, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-zen-not-found',
  standalone: true,
  templateUrl: './zen-not-found.component.html',
  styleUrls: ['./zen-not-found.component.scss'],
})
export class ZenNotFoundComponent {
  private route = inject(ActivatedRoute);
  message: string =
    this.route.snapshot.data?.['message'] ??
    "Oops, I couldn't find what you were looking for.<br />Please check the spelling in the URL.";
}
